import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import About from "./components/About";
import Imprint from "./components/Imprint";
import Privacy from "./components/Privacy";
import CookieConsent from "./components/CookieConsent";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { routeConfig } from "./config/layout/routes";
import "./App.css";

const TitleUpdater: React.FC = () => {
  const location = useLocation();

  React.useEffect(() => {
    const currentRoute = Object.values(routeConfig).find(
      (route) => route.path === location.pathname
    );
    document.title = currentRoute?.title || routeConfig.home.title;
  }, [location]);

  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <TitleUpdater />
        <ScrollToTop />
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route
              path={routeConfig.home.path}
              element={
                <>
                  <Hero />
                  <Services />
                </>
              }
            />
            <Route path={routeConfig.services.path} element={<Services />} />
            <Route path={routeConfig.gallery.path} element={<Gallery />} />
            <Route path={routeConfig.contact.path} element={<Contact />} />
            <Route path={routeConfig.about.path} element={<About />} />
            <Route path={routeConfig.imprint.path} element={<Imprint />} />
            <Route path={routeConfig.privacy.path} element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
};

export default App;
